/**
 * Demo 页面假数据
 */
import moment from 'moment';

// 用户基础信息
export const USER_BASE_INFO = {
  wxAvatar: '',
  wxNickName: '运动达人',
  gender: 1,
  countryCode: '86',
  phone: '13800138000',
  userId: 'demo_user_001',
};

// 所有年份
export const ALL_YEARS = [2024, 2025, 2026];

// 事件类型定义（参考 StoreDetailDialog）
export const EVENT_TYPES = {
  ENTER_STORE: '进店',
  TREADMILL: '跑步机',
  PERSONAL_TRAINING: '私教',
  GROUP_CLASS: '团课',
  CHECKOUT: '离店',
  ONLINE_TRAINING: '入镜训练',
};

export const EVENT_COLORS = {
  ENTER_STORE: '#10b981',
  TREADMILL: '#3b82f6',
  PERSONAL_TRAINING: '#8b5cf6',
  GROUP_CLASS: '#f59e0b',
  CHECKOUT: '#ef4444',
  ONLINE_TRAINING: '#fa8c16',
};

// 生成全年数据
const generateYearData = (year) => {
  const data = [];
  const start = moment(`${year}-01-01`);
  const end = moment(`${year}-12-31`);

  for (let m = start.clone(); m.isSameOrBefore(end); m.add(1, 'day')) {
    const date = m.format('YYYY-MM-DD');
    const dayOfWeek = m.isoWeekday();
    const weekdayName = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][dayOfWeek - 1];

    // 随机生成训练数据（周末更活跃）
    const isWeekend = dayOfWeek >= 6;
    const maxInStore = isWeekend ? 2 : 1;
    const maxOnline = isWeekend ? 2 : 1;

    const inStoreEventTimes = Math.random() > 0.6 ? Math.floor(Math.random() * (maxInStore + 1)) : 0;
    const onlineTrainingTimes = Math.random() > 0.7 ? Math.floor(Math.random() * (maxOnline + 1)) : 0;
    const totalAvailableTimes = inStoreEventTimes + onlineTrainingTimes;
    const meetStandard = totalAvailableTimes > 0 && Math.random() > 0.3;

    // 生成事件详情
    const events = [];
    const locations = [];

    // 生成到店训练事件（包含完整生命周期）
    for (let i = 0; i < inStoreEventTimes; i++) {
      const hour = 7 + Math.floor(Math.random() * 13); // 7:00 - 20:00
      const minute = Math.floor(Math.random() * 60);
      const baseTime = m.clone().hour(hour).minute(minute);

      const storeName = ['万象城店', '城西银泰店', '滨江宝龙店', '下沙银泰店'][Math.floor(Math.random() * 4)];
      const baseEventId = `ev_${date}_store_${i}`;

      // 1. 进店事件
      events.push({
        eventType: 'inStore',
        eventCode: 'ENTER_STORE',
        eventId: `${baseEventId}_enter`,
        time: baseTime.format('HH:mm'),
        timestamp: baseTime.valueOf(),
        storeName,
        durationSeconds: 0, // 瞬时事件
        meetStandard: false,
        reviewStatus: null,
        riskControlType: null,
        locationVerified: Math.random() > 0.2,
        isInstant: true, // 标记为瞬时事件
      });

      // 2. 训练事件（随机选择类型）
      const trainingTypes = ['TREADMILL', 'PERSONAL_TRAINING', 'GROUP_CLASS'];
      const trainingType = trainingTypes[Math.floor(Math.random() * trainingTypes.length)];
      const trainingDuration = (30 + Math.floor(Math.random() * 60)) * 60; // 30-90分钟
      const trainingTime = baseTime.clone().add(5 + Math.floor(Math.random() * 15), 'minutes');

      events.push({
        eventType: 'inStore',
        eventCode: trainingType,
        eventId: `${baseEventId}_training`,
        time: trainingTime.format('HH:mm'),
        timestamp: trainingTime.valueOf(),
        storeName,
        durationSeconds: trainingDuration,
        meetStandard: Math.random() > 0.3,
        reviewStatus: ['PASS', 'PENDING', 'NOT_APPROVED'][Math.floor(Math.random() * 3)],
        riskControlType: Math.random() > 0.8 ? 'risk' : null,
        locationVerified: Math.random() > 0.2,
        isInstant: false,
      });

      // 3. 离店事件
      const checkoutTime = trainingTime.clone().add(trainingDuration, 'seconds').add(2, 'minutes');
      events.push({
        eventType: 'inStore',
        eventCode: 'CHECKOUT',
        eventId: `${baseEventId}_checkout`,
        time: checkoutTime.format('HH:mm'),
        timestamp: checkoutTime.valueOf(),
        storeName,
        durationSeconds: 0, // 瞬时事件
        meetStandard: false,
        reviewStatus: null,
        riskControlType: null,
        locationVerified: false,
        isInstant: true,
      });

      // 生成位置记录
      if (Math.random() > 0.2) {
        locations.push({
          time: baseTime.subtract(15, 'minutes').format('HH:mm'),
          timestamp: baseTime.valueOf() - 15 * 60 * 1000,
          locationType: Math.random() > 0.5 ? 'GPS' : 'WIFI',
          locationName: ['万象城乐刻门店', '城西银泰乐刻门店', '滨江宝龙乐刻门店'][Math.floor(Math.random() * 3)],
          isStoreLocation: true,
          accuracy: Math.floor(Math.random() * 20) + 10,
        });
      }
    }

    // 生成入镜训练事件
    for (let i = 0; i < onlineTrainingTimes; i++) {
      const hour = 18 + Math.floor(Math.random() * 4); // 18:00 - 22:00
      const minute = Math.floor(Math.random() * 60);
      const durationSeconds = (20 + Math.floor(Math.random() * 40)) * 60; // 20-60分钟
      const eventTime = m.clone().hour(hour).minute(minute);

      events.push({
        eventType: 'onlineTraining',
        eventCode: 'ONLINE_TRAINING',
        eventId: `ev_${date}_online_${i}`,
        time: eventTime.format('HH:mm'),
        timestamp: eventTime.valueOf(),
        courseName: ['燃脂塑形', '瑜伽基础', '核心训练', '拉伸放松'][Math.floor(Math.random() * 4)],
        durationSeconds,
        meetStandard: Math.random() > 0.3,
        isInstant: false,
      });
    }

    // 按时间排序
    events.sort((a, b) => a.timestamp - b.timestamp);
    locations.sort((a, b) => a.timestamp - b.timestamp);

    data.push({
      date,
      dayOfWeek,
      weekdayName,
      inStoreEventTimes,
      onlineTrainingTimes,
      totalAvailableTimes,
      meetStandard,
      events,
      locations,
    });
  }

  return data;
};

// 生成 2025 和 2026 年的数据
export const YEAR_DATA_2025 = generateYearData(2025);
export const YEAR_DATA_2026 = generateYearData(2026);

// 联名卡订单数据
export const CO_BRAND_ORDERS = [
  {
    id: 1,
    lekeOrderNo: 'LK20260115001',
    lekeOrderItemNo: 'LKI20260115001001',
    activateStatus: 3,
    realNameDecrypt: '张三',
    idCardNoDecrypt: '330106199001010011',
    userPhoneDecrypt: '+86 13800138000',
    payTime: moment('2026-01-15 10:30:00').valueOf(),
    activateTime: moment('2026-01-15 10:35:00').valueOf(),
    policyNo: 'POL2026011500001',
  },
  {
    id: 2,
    lekeOrderNo: 'LK20260220002',
    lekeOrderItemNo: 'LKI20260220002001',
    activateStatus: 2,
    realNameDecrypt: '张三',
    idCardNoDecrypt: '330106199001010011',
    userPhoneDecrypt: '+86 13800138000',
    payTime: moment('2026-02-20 14:20:00').valueOf(),
    activateTime: null,
    policyNo: 'POL2026022000002',
  },
];
